// 3rd Party
import React from 'react';

// Components
import { FormattedMessageV2 } from '@/views/components/i18n';

// Utils
import { formatMessage } from '@/utils/i18n';

// Assets
import SuccessfulUpload from '@/images/design-system-v2/upload/successfulUpload.svg';
import FailedUpload from '@/images/design-system-v2/upload/failedUpload.svg';

type Props = {
  success: boolean;
  i18nBasePath: string;
};

const UploadStatus: React.FC<Props> = ({ success, i18nBasePath }) => (
  <div className="upload-status">
    <img
      alt={formatMessage(`${i18nBasePath}.Alt.${success ? 'SuccessfulUploadImage' : 'FailedUploadImage'}`)}
      src={success ? SuccessfulUpload : FailedUpload}
    />

    <div className="upload-status-title">
      <FormattedMessageV2 toLocalize={`${i18nBasePath}.${success ? 'SuccessfullyUploaded' : 'FailedUpload'}`} />
    </div>

    <div className="upload-status-subtitle">
      <FormattedMessageV2 toLocalize={`${i18nBasePath}.${success ? 'AllItemsReady' : 'CouldNotCompleteProcessing'}`} />
    </div>
  </div>
);

export default UploadStatus;
